export default {
  INIT_STATE: "native/INIT_STATE",
  SET_BIOMETRICS_FLOW_ENABLED: "native/SET_BIOMETRICS_FLOW_ENABLED",
  SET_BIOMETRICS_ENROLLMENT_STATUS: "native/SET_BIOMETRICS_ENROLLMENT_STATUS"
};
